<template>
  <v-card :loading="loading">
    <v-toolbar
      color="white"
      class="elevation-0"
    >
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
      <!-- <v-spacer />
      <v-btn-toggle
        v-model="timeUnit"
        dir="ltr"
      >
        <v-btn
          small
          text
          value="year"
        >
          שנה
        </v-btn>
        <v-btn
          small
          text
          value="month"
        >
          חודש
        </v-btn>
        <v-btn
          small
          text
          value="day"
        >
          יום
        </v-btn>
      </v-btn-toggle> -->
    </v-toolbar>
    <v-card-text v-if="!loading">
      <v-chart
        :options="chart"
        :autoresize="true"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  data() {
    return {

    };
  },

  computed: {},

  props: ["title", "loading", "error", "chart"],

  components: {
    "v-chart": ECharts
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
